import React, { useState, useRef, useEffect } from "react";
import CAR_MODELS from "../../Data/models";
import Arrow from "./Icons/Arrow";

const CarModelGallery = ({ onModelSelect, selectedId }) => {
  // El resaltado se deriva del estado del form, asi la tarjeta marcada siempre
  // coincide con el modelo que termina viajando en el submit. -1 = sin elegir.
  const selectedIndex = CAR_MODELS.findIndex((model) => model.id === selectedId);
  const [viewIndex, setViewIndex] = useState(0);
  const [sliderValue, setSliderValue] = useState(0);

  const scrollContainerRef = useRef(null);
  const sliderRef = useRef(null);
  const thumbRef = useRef(null);

  // Todas las vias de seleccion pasan por aca, para que el padre se entere
  // siempre (antes las flechas movian el resaltado sin avisarle).
  const selectIndex = (index) => {
    if (index < 0 || index >= CAR_MODELS.length) return;
    setViewIndex(index);
    if (onModelSelect) onModelSelect(CAR_MODELS[index]);
  };

  const handleSliderChange = (e) => {
    const value = parseInt(e.target.value);
    setSliderValue(value);

    const newViewIndex = (value / 100) * (CAR_MODELS.length - 1);
    setViewIndex(newViewIndex);
  };

  useEffect(() => {
    if (thumbRef.current && sliderRef.current) {
      // Position thumb based on slider value
      const trackWidth = sliderRef.current.offsetWidth;
      const leftPos = (sliderValue / 100) * (trackWidth - 48);
      thumbRef.current.style.left = `${leftPos}px`;
    }
  }, [sliderValue]);

  useEffect(() => {
    if (scrollContainerRef.current) {
      const scrollAmount =
        viewIndex * scrollContainerRef.current.children[0].offsetWidth;
      scrollContainerRef.current.scrollTo({
        left: scrollAmount,
        behavior: "smooth",
      });
    }
  }, [viewIndex]);

  // Acompanamos con el slider y el scroll la seleccion que llega del padre.
  useEffect(() => {
    if (selectedIndex < 0) return;
    const value = (selectedIndex / (CAR_MODELS.length - 1)) * 100;
    setSliderValue(value);
    setViewIndex(selectedIndex);
  }, [selectedIndex]);

  // Las flechas tambien seleccionan; sin nada elegido, arrancan por el primero.
  const handlePrev = () => selectIndex(selectedIndex <= 0 ? 0 : selectedIndex - 1);

  const handleNext = () => selectIndex(selectedIndex < 0 ? 0 : selectedIndex + 1);

  return (
    <div className="w-full">
      {/* Car Model Carousel */}
      <div className="relative overflow-hidden">
        <div
          ref={scrollContainerRef}
          className="flex overflow-x-scroll scroll-smooth no-scrollbar gap-4">
          {CAR_MODELS.map((model, index) => (
            <div
              key={model.id || `model-${index}`}
              className={`w-fit bg-[#F8F8F8] flex-shrink-0 flex flex-col items-center p-4 border ${
                selectedIndex === index
                  ? "border-[#05141F] bg-[#F8F8F8]"
                  : "border-[#CDD0D2]"
              } cursor-pointer`}
              onClick={() => selectIndex(index)}>
              <img
                src={model.image}
                alt={model.name}
                className="w-[172px] md:w-[256px] h-[88px] object-contain mb-3"
              />
              <h5 className="text-center font-bold">{model.name}</h5>
            </div>
          ))}
        </div>
      </div>

      {/* Navigation Controls with Range Slider */}
      <div className="flex items-center justify-center mt-5 overflow-hidden">
        <div className="relative flex-1 h-[1px] bg-gray-300 my-3">
          {/* Hidden range input that's still interactive */}
          <input
            ref={sliderRef}
            type="range"
            min="0"
            max="100"
            step="any"
            value={sliderValue}
            onChange={handleSliderChange}
            className="absolute top-[-12px] w-full h-6 opacity-0 cursor-grab z-10"
          />

          {/* Custom thumb element */}
          <div
            ref={thumbRef}
            className="absolute top-[-12px] flex flex-row border-none"
            style={{ left: "0px" }} // Initial position, will be updated by useEffect
          >
            <div
              onClick={handlePrev}
              className="border-none w-6 h-6 flex items-center justify-center rounded-l-full bg-[#05141F] disabled:opacity-50 cursor-pointer">
              <Arrow fill="#fff" className="rotate-180" />
            </div>
            <div
              onClick={handleNext}
              className="border-none w-6 h-6 flex items-center justify-center rounded-r-full bg-[#05141F] disabled:opacity-50 cursor-pointer">
              <Arrow fill="#fff" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CarModelGallery;
